<template lang="pug">
div
  UiCardSection
    UiStack
      UiStackItem(fill)
        .ui-card-section-title {{ $t("resellers.tabs.pricing") }}
  UiCardSection
    .form-container
      UiFormGroup(
        :label="$t('resellers.line_price')"
        label-for="line-price-input"
        label-cols="4"
      )
        UiInput#line-price-input(
          v-model="reseller.line_price"
          type="number"
        )
      UiFormGroup(
        :label="$t('resellers.invoice_price')"
        label-for="invoice-price-input"
        label-cols="4"
      )
        UiInput#invoice-price-input(
          v-model="reseller.invoice_price"
          type="number"
        )
      UiFormGroup(
        :label="$t('resellers.every_invoice_price')"
        label-for="every-invoice-price-input"
        label-cols="4"
      )
        UiInput#every-invoice-price-input(
          v-model="reseller.every_invoice_price"
          type="number"
        )
      UiFormGroup
        UiStack
          UiStackItem(fill)
          UiStackItem
            UiButton(
              variant="primary"
              @click="save"
              icon="Check"
            ) {{ $t("actions.save") }}
</template>

<script>
import router from "@/router";
import ApiResellers from "@/api/resellers.js";

export default {
  data() {
    return {
      reseller: {},
    };
  },

  methods: {
    getData() {
      ApiResellers.getReseller(this.$route.params.id).then((resp) => {
        this.reseller = resp.data.reseller;
      });
    },

    save() {
      ApiResellers.updateReseller(this.reseller.id, this.reseller).then(
        (resp) => {
          this.reseller = resp.data.reseller;
        },
      );
    },
    goBack() {
      router.push("/resellers");
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
